import {
  FlatList,
  Keyboard,
  LayoutChangeEvent,
  Modal,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import {
  color_main,
  white,
  color_333333,
  Color43C6A7,
  Color50F1AB,
  white30,
  black90,
  black,
} from "../../assets/style/colors";
import LinearGradient from "react-native-linear-gradient";
import { AuthNavProps } from "../navigation/auth/AuthParamList";
import { invite } from "../../net/service";
import * as ImSdk from "../../../imsdk/api/index";
import { showToast } from "../../components/Toast";
import { hideLoading, showLoading } from "../../components/Loading";
import {
  Str_Confirm,
  Str_ServiceNumberCommonErr,
  Str_ServiceNumberCommonErr1,
  Str_ServiceNumberInputHint,
  Str_openPrivateChat,
} from "../../language/string_res";
import { isIos } from "../../AppEvent";
import { getLanguage } from "../../language/i18n";
import { ImageView } from "../../components/ImageView";
import { ChangeLanguageModal } from "../setting/other_setting";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { ButtonView } from "../../components/ButtonView";
import { LayoutRectangle } from "react-native/Libraries/Types/CoreEventTypes";
import { Div } from "../Chat/ChatSearch";
import { useIsFocused } from "@react-navigation/core";
import { fetch } from "@react-native-community/netinfo";
// SVG 组件
import Network from "../../assets/svg/ic_network.svg";
import Logo from "../../assets/svg/ic_round_logo.svg";
import MisoLogo from "../../assets/svg/ic_round_logo_miso.svg";
import { isMiso } from "../../../imsdk/api/index";
// 扫描功能已移除
// import ScannerModal from "./ScannerModal";
// import { cameraRequest } from "../../utils/RequestPermission";

export const ServiceNumber = ({
  navigation,
  route,
}: AuthNavProps<"ServiceNumber">) => {
  console.log('🔵 [ServiceNumber] 组件开始渲染');
  
  const isAddAccount = route?.params?.isAddAccount ?? false;
  const lastUid = route?.params?.lastUid ?? 0;
  const defCode = route.params?.vcode;
  const [input, setInput] = useState(defCode ?? "");
  const [langVisible, setLangVisible] = useState(false);
  const [codes, setCodes] = useState<string[]>([]);
  const [showHistory, setShowHistory] = useState(false);
  const [rectangle, setRectangle] = useState<LayoutRectangle>(
    {} as LayoutRectangle
  );
  const [parentRectangle, setParentRectangle] = useState<LayoutRectangle>(
    {} as LayoutRectangle
  );
  const insets = useSafeAreaInsets();
  const isFocused = useIsFocused();
  console.log('🔵 [ServiceNumber] Hooks 初始化完成, insets:', insets);

  useEffect(() => {
    if (isFocused) {
      AsyncStorage.getItem("InvitationCodes").then((r) => {
        if (r) {
          const parse = JSON.parse(r) as string[];
          setCodes(parse);
          if (!defCode || defCode.length === 0) {
            if (parse.length > 0) {
              setInput(parse[parse.length - 1]);
            }
          }
        }
      });
    }
  }, [isFocused]);
  // Immerse related code removed for web compatibility

  // 扫描功能已移除，相关 useEffect 已删除

  useEffect(() => {
    if (isIos && Platform.OS !== 'web') {
      // 网络权限弹窗
      fetch().then().catch((e) => {
        console.warn('[ServiceNumber] NetInfo fetch failed:', e);
      });
    }
  }, []);


  const cacheCodes = () => {
    const data = codes;
    const includes = data.includes(input);
    if (!includes) {
      data.push(input);
    }
    AsyncStorage.setItem("InvitationCodes", JSON.stringify(data)).then();
  };
  const deleteCode = (item: string) => {
    const next = codes.filter((i) => i !== item);
    setCodes(next);
    AsyncStorage.setItem("InvitationCodes", JSON.stringify(next)).then();
    if (input === item) {
      setInput("");
    }
  };

  const confirm = () => {
    if (!input || input.length === 0) {
      showToast(Str_ServiceNumberInputHint);
      return;
    }
    if (input.length !== 6) {
      showToast(Str_ServiceNumberCommonErr1);
      return;
    }
    showLoading();
    Keyboard.dismiss();
    invite({ vcode: input, lang: getLanguage() })
      .then((data) => {
        hideLoading();
        if (data.code === 0 && data.data && data.data.connect_url) {
          cacheCodes();
          // ImSdk.getInstance().setBaseUrl(data.data.connect_url);
          navigation.navigate("Login", {
            vcode: input,
            isAddAccount: isAddAccount,
            lastUid: lastUid,
          });
        } else {
          showToast(data.msg ?? Str_ServiceNumberCommonErr);
        }
      })
      .finally(() => {
        hideLoading();
      });
  };
  const onLayout = (event: LayoutChangeEvent) => {
    setRectangle(event.nativeEvent.layout);
  };
  const onParentLayout = (event: LayoutChangeEvent) => {
    setParentRectangle(event.nativeEvent.layout);
  };

  const dismissHistory = () => {
    setShowHistory(false);
  };

  const HistoryItemClick = (item: string) => {
    setInput(item);
    dismissHistory();
  };
  const HistoryCode = () => {
    return (
      <Modal
        visible={showHistory}
        transparent={true}
        statusBarTranslucent={true}
        onRequestClose={dismissHistory}
      >
        <Pressable style={{ flex: 1 }} onPress={dismissHistory}>
          <FlatList
            data={codes}
            style={{
              maxHeight: 300,
              position: "absolute",
              start: 27,
              end: 27,
              height: codes.length * 40,
              backgroundColor: white,
              borderRadius: 4,
              top: parentRectangle.y + rectangle.y + rectangle.height + 4,
            }}
            keyExtractor={(item, index) => `${index}_${item}`}
            ItemSeparatorComponent={() => <Div />}
            renderItem={({ item }) => {
              return (
                <View
                  style={{
                    width: "100%",
                    height: 40,
                    justifyContent: "center",
                  }}
                >
                  <ButtonView
                    onPress={() => HistoryItemClick(item)}
                    style={{
                      justifyContent: "center",
                      height: 40,
                      alignItems: "flex-start",
                      paddingHorizontal: 16,
                      width: "100%",
                    }}
                    textStyle={{ color: color_333333, fontSize: 16 }}
                    text={item}
                  />
                  <Pressable
                    onPress={() => deleteCode(item)}
                    style={{
                      position: "absolute",
                      right: 0,
                      paddingHorizontal: 10,
                      height: 40,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ImageView
                      disabled={true}
                      imgStyle={{ width: 20, height: 20 }}
                      source={require("../../assets/image/icon_close.png")}
                    />
                  </Pressable>
                </View>
              );
            }}
          />
        </Pressable>
      </Modal>
    );
  };

  console.log('🔵 [ServiceNumber] 准备渲染 JSX');
  
  try {
    return (
      <LinearGradient
        colors={[Color50F1AB, Color43C6A7]}
        start={{ x: 0, y: 0 }}
        end={{ x: 0, y: 1 }}
        style={{ flex: 1 }}
      >
      <ImageView
        style={{
          position: "absolute",
          bottom: 0,
          start: 0,
          end: 0,
          alignItems: "center",
        }}
        imgStyle={{ width: 375, height: 304 }}
        source={require("../../assets/image/ic_invitation_bom.png")}
      />
      <View
        onLayout={onParentLayout}
        style={{
          alignItems: "center",
          justifyContent: "center",
          marginTop: insets.top + 70,
          width: "100%",
        }}
      >
          {isMiso ? <MisoLogo width={80} height={80} /> : <Logo width={80} height={80} />}
        <Text
          style={{
            fontSize: 32,
            fontFamily: "",
            color: white,
            fontWeight: "600",
            marginTop: 20,
          }}
        >
          {Str_ServiceNumberInputHint || '请输入服务号'}
        </Text>
        <Text
          style={{
            fontSize: 20,
            fontFamily: "",
            color: white,
            fontWeight: "400",
            marginTop: 10,
          }}
        >
          {Str_openPrivateChat || '开启私聊'}
        </Text>
        <View
          onLayout={onLayout}
          style={[
            {
              marginTop: 60,
              backgroundColor: white30,
              borderRadius: 100,
              width: "100%",
              paddingStart: 16,
              paddingEnd: 16,
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              height: 50,
            },
            // Web 优化：限制最大宽度
            Platform.OS === 'web' && {
              maxWidth: 400,
              alignSelf: 'center',
            },
          ]}
        >
          <TextInput
            focusable={true}
            inputMode={"numeric"}
            selectionColor={color_main}
            textAlign="center"
            placeholder={Str_ServiceNumberInputHint}
            placeholderTextColor={black90}
            style={[
              {
                fontSize: 18,
                width: "100%",
                color: black,
                textAlign: "center",
                fontWeight: "600",
                paddingLeft: codes.length > 0 ? 40 : 0,
                paddingRight: codes.length > 0 ? 40 : 0,
                backgroundColor: 'transparent',
                borderWidth: 0,
              },
              // Web 特定样式通过全局 CSS 处理，这里只设置 React Native 支持的样式
            ]}
            value={input}
            onChangeText={setInput}
            onSubmitEditing={confirm}
          />
          {codes.length > 0 && (
            <ImageView
              style={{
                justifyContent: "center",
                paddingHorizontal: 12,
                alignItems: "center",
              }}
              onClick={() => setShowHistory(true)}
              imgStyle={{ width: 16, height: 16, objectFit: "contain" }}
              source={require("../../assets/image/icon_arr_down.png")}
            />
          )}
        </View>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={confirm}
          style={[
            { width: "100%" },
            // Web 优化：限制最大宽度
            Platform.OS === 'web' && {
              maxWidth: 400,
              alignSelf: 'center',
            },
          ]}
        >
          <View style={styles.button}>
            <Text
              style={{
                color: Color43C6A7,
                fontSize: 18,
                fontWeight: "bold",
                fontFamily: "",
                width: "100%",
                textAlign: "center",
              }}
            >
              {Str_Confirm || '确认'}
            </Text>
          </View>
        </TouchableOpacity>
      </View>
      <ChangeLanguageModal
        visible={langVisible}
        close={() => setLangVisible(false)}
      />
      {!(isAddAccount && isAddAccount) && (
        <View
          style={{
            flexDirection: "row",
            position: "absolute",
            end: 16,
            top: insets.top + 20,
          }}
        >
          <Pressable style={{}} onPress={() => setLangVisible(true)}>
            <Network fill={white} width={30} height={30} />
          </Pressable>
        </View>
      )}

      {isAddAccount && isAddAccount && (
        <ImageView
          onClick={() => navigation.goBack()}
          style={{
            position: "absolute",
            top: insets.top + 20,
            height: 44,
            paddingHorizontal: 24,
          }}
          source={require("../../assets/image/icon_back.png")}
        />
      )}
      <HistoryCode />
      <ChangeLanguageModal
        visible={langVisible}
        close={() => setLangVisible(false)}
      />
    </LinearGradient>
    );
  } catch (error: any) {
    console.error('❌ [ServiceNumber] 渲染错误:', error);
    return (
      <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', padding: 20, backgroundColor: '#ffffff' }}>
        <Text style={{ color: 'red', fontSize: 16, fontWeight: 'bold' }}>ServiceNumber 渲染错误</Text>
        <Text style={{ color: 'red', marginTop: 10 }}>{error?.toString()}</Text>
        {error?.stack && <Text style={{ color: 'red', marginTop: 10, fontSize: 12 }}>{error.stack}</Text>}
      </View>
    );
  }
};

const styles = StyleSheet.create({
  button: {
    paddingVertical: 15,
    alignItems: "center",
    width: "100%",
    backgroundColor: white,
    justifyContent: "center",
    borderRadius: 30,
    marginTop: 26,
    // Web 优化
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
      userSelect: 'none',
    }),
  },

  placeholder: {
    fontSize: 16,
    flex: 1,
    textAlign: "center",
    color: black90,
    fontWeight: "400",
    fontFamily: "",
  },

  input: {
    fontSize: 18,
    flex: 1,
    textAlign: "center",
    color: black,
    fontWeight: "600",
    fontFamily: "",
  },
});
